import $technicalAssistance from "./technicalAssistance.signal";

export const handleViewTechnicalAssistanceClick = (technicalAssistance) => $technicalAssistance.update({ technicalAssistance });

export const handleCloseTechnicalAssistanceModal = () => $technicalAssistance.reset();
